import Vue from 'vue'
import axios from 'axios'
import { makeUrl, debug, defineString } from '../components/globals'




 const storeConfig = {

    namespaced: true,

    state: {
      configLoaded: false,
      server: {},
      consultingMds: []
    },

    getters: {
      configLoaded: state => state.configLoaded,
      server: state => state.server ? state.server : {},
      consultingMds: state => state.consultingMds ? state.consultingMds : [],
      // consultUid: state => (state.server && state.server.suid) ? state.server.suid : '',

      institutionName: state => (state.server && state.server.institutionName)
        ? state.server.institutionName : '',
      institutionAddress: state => (state.server && state.server.institutionAddress)
        ? state.server.institutionAddress : '',
      institutionLogo: state => (state.server && state.server.institutionLogo)
        ? state.server.institutionLogo : '',

      // institutionName: state => state.server.institutionName,
      // versionNumber: state => state.server.versionNumber,
      // versionDate: state => state.server.versionDate,
      // consultingMds: () => ['111', '222', '333']
    },

    actions: {
      loadConfig({ state, commit }) {
        debug('storeConfig loadConfig')
        let url = makeUrl('service.cgi?get=config&tmp='+ (new Date().getTime()));
        
        debug('storeConfig loadConfig: URL = ' + url);

        return new Promise((resolve, reject) => {
          axios.get(url)
            .then(response => {
              console.log('storeConfig loadConfig: success: '
                +JSON.stringify(response.data));

              // commit('testMut', 'abc');
              commit('setConfig', response.data);

              if (state.server) {
                window.tm_ui_debug = defineString(state.server.tm_ui_debug)
                console.log('storeConfig loadConfig: tm_ui_debug=' + window.tm_ui_debug)
              } else {
                console.log('storeConfig loadConfig: no server config loaded');
                reject('Cannot load the server configuration.')
              }
              debug('storeConfig loadConfig: success: CONFIG SHOULD BE SET NOW');

              debug('storeConfig loadConfig: IN=' + state.server.institutionName);


              resolve(response)
            }, error => {
              debug('storeConfig loadConfig: error: '+JSON.stringify(error));
              reject(error)
            }
          )
        })
      },

    },

    mutations: {
      // set(state, {name, data}) {
      //   debug('STORE set: ' + name + ' = ' + JSON.stringify(data));
      //   Vue.set(state, name, data)
      // },

      // setObject(state, {name, data}) {
      //   debug('STORE setObject: ' + name + ' = ' + JSON.stringify(data));
      //   Vue.set(state, name, data)
      // },

      // setValue(state, {name, data}) {
      //   debug('STORE setValue: ' + name + ' = ' + data);
      //   Vue.set(state, name, data);
      // },

      // toggle(state, {name}) {
      //   const val = !state[name];
      //   debug('STORE toggle: ' + name + ' = ' + val);
      //   Vue.set(state, name, val);
      // },

      testMut(state, str) {
        debug('STORE testMut: str=' + str);
        // Vue.set(state, name, data);
      },


      setConfig(state, newConfig) {
        debug('-------------------------------------');

        debug('setConfig: ' + JSON.stringify(newConfig));
        Vue.util.extend(state.server, newConfig.server);
        Vue.util.extend(state.consultingMds, newConfig.consultingMds);
        Vue.set(state, 'configLoaded', true);
      },
    },
  }

export default storeConfig

